import { CloudPremisePlugin } from "@cloudpremise/portal_core";
import { routes, menus, userMenus, footerMenus, settingMenus, adminMenus } from "./src";
import packageJson from "./package.json";

class Admin extends CloudPremisePlugin {};

const AdminPlugin = new Admin ({
    name: packageJson.name,
    description: packageJson.description,
    status: packageJson.status,
    routes: routes,
    menus: menus,
    userMenus: userMenus,
    footerMenus: footerMenus,
    settingMenus: settingMenus,
    adminMenus: adminMenus,
    render: () => {
        return null
    }
});

export default AdminPlugin;